import { useQuery } from 'react-query';

import { getValidationActivitiesDrillDown as queryFn } from 'api/endPoints/getValidationActivitiesDrillDown';

export const useQueryGetValidationActivitiesDrillDown = (params) => {
    return useQuery({
        queryKey: ['getValidationActivitiesDrillDown', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.componentId),
    });
};
